export const INIT_VIDEOS = 'INIT_VIDEOS';
export const UPDATE_VIDEO = 'UPDATE_VIDEO';
export const DELETE_VIDEO = 'DELETE_VIDEO';
export const ADD_VIDEO = 'ADD_VIDEO';

export default { INIT_VIDEOS, UPDATE_VIDEO, DELETE_VIDEO, ADD_VIDEO };
